import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { AllergenDetailsPage, AllergensPage } from './pages'

const AllergensRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.ALLERGENS.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={AllergensPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.ALLERGEN_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={AllergenDetailsPage}
    />
  </Switch>
)

export default AllergensRouter
